import React, { Component } from 'react'
import AppHeader from "../Misc/AppHeader";
import queryString from 'query-string'
import { BASE_URL_2, catererDomains, districtDomains } from "../../server/constants";
import NotificationSystem from 'react-notification-system';
import PropTypes from 'prop-types'
import { _addNotification, _addNotificationError } from "../../server/util";
import Logo from './logo';
import './login.css';

let user = {
    "username": '',
    "fToken": '',
    "password": '',
    "isCaterer": false,
    "isDistrict": false
}

class reset extends Component {
    componentDidMount = () => {
        const parsed = queryString.parse(window.location.search);
        const urlParts = window.location.host.split('.');
        if (urlParts.length === 2) {
            if (catererDomains.includes(urlParts[0])) {
                user.isCaterer = true;
            }
            if (districtDomains.includes(urlParts[0])) {
                user.isDistrict = false;
            }
        }
        user.username = parsed["uid"];
        user.fToken = parsed["token"];
        this.validateToken(user);
        this._notificationSystem = this.refs.notificationSystem;
    };

    constructor() {
        super();
        this.state = {
            "password": '',
            "validToken": '',
            "isCaterer": false
        };
        this.checkPass = this.checkPass.bind(this);
        this.validateToken = this.validateToken.bind(this);

    }
    validateToken = (_user) => {
        let url = `${BASE_URL_2}/isLinkValidate?token=${_user.fToken}&userId=${_user.username}${_user.isCaterer ? '&isCaterer=true' : (_user.isDistrict ? '&isDistrict=true' : '')}`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            if ((data || false) === false) {
                //_addNotificationError('Link has expired please try again with new link !', this);
                this.setState({ validToken: false })

            } else {
                this.setState({ validToken: true }, () => {
                    this.validatePasswordStrength();
                })
            }
        })
            .catch(
                (error) => {
                    _addNotificationError('Something went wrong. Please contact system administrator.', this);
                    setTimeout(() => {
                        this.context.router.history.push('/404');
                    }, 3000);
                }
            )
    }

    onChange(e) {
        this.state.password = e.target.value;
    }
    handleSubmit(event) {
        event.preventDefault();
        user.password = this.state.password;
        let url = `${BASE_URL_2}/recoveryPassword?${user.isCaterer ? 'isCaterer=true' : (user.isDistrict ? 'isDistrict=true' : '')}`
        fetch(url, {
            method: 'post',
            body: JSON.stringify(user),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    _addNotificationError('Link has expired please try again with new link !', this);
                }
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            document.getElementById("message2").style.color = "red";
            //document.getElementById("message").innerHTML = "Your password has been reset successfully";
            _addNotification('Your password has been set successfully.', this);
            console.log(data);
            //window.location.replace('/login')
            document.getElementById("submit").disabled = true;
            setTimeout(() => {
                this.context.router.history.push('/login');
            }, 3000);

        })
            .catch(
                (error) => {
                    _addNotificationError('Unable set password please try again !', this);
                    console.log('Get Teachers and Class list response', error)
                }
            )
    }


    checkPass() {
        if (document.getElementById('password').value ===
            document.getElementById('cpwd').value) {
            if (this.checkStrength()) {
                document.getElementById('message').innerHTML = '';
                document.getElementById("submit").disabled = false;
            } else {
                document.getElementById('message').innerHTML = '';
                document.getElementById("submit").disabled = true;
            }

        } else {
            document.getElementById('message').style.color = 'red';
            document.getElementById('message').innerHTML = 'Passwords do not match';
            document.getElementById("submit").disabled = true;
        }

        if (document.getElementById('password').value === '') {
            document.getElementById('message').innerHTML = '';

        }
    }
    checkStrength = () => {
        let password = document.getElementById('password').value;
        let isValid = true;

        //If password contains both lower and uppercase characters
        if (!password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
            isValid = false;
        }
        //If it has numbers and characters
        if (!password.match(/([0-9])/)) {
            isValid = false;
        }
        //If it has one special character
        if (!password.match(/([!,%,&,@,$,^,*,?,_,~])/)) {
            isValid = false;
        }
        //If password is greater than 7
        if (!password.length > 7) {
            isValid = false;
        }
        return isValid;
    }

    validatePasswordStrength = () => {
        //let state = false;
        let password = document.getElementById("password");
        let passwordStrength = document.getElementById("password-strength");
        let lowUpperCase = document.querySelector(".low-upper-case i");
        let number = document.querySelector(".one-number i");
        let specialChar = document.querySelector(".one-special-char i");
        let eightChar = document.querySelector(".eight-character i");

        password.addEventListener("keyup", function () {
            let pass = document.getElementById("password").value;
            checkStrength(pass);
        });

        /* const toggle=()=>{
            if(state){
                document.getElementById("password").setAttribute("type","password");
                state = false;
            }else{
                document.getElementById("password").setAttribute("type","text")
                state = true;
            }
        } */

        /* const myFunction=(show)=>{
            show.classList.toggle("fa-eye-slash");
        } */

        const checkStrength = (password) => {
            let strength = 0;

            //If password contains both lower and uppercase characters
            if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
                strength += 1;
                lowUpperCase.classList.remove('fa-circle');
                lowUpperCase.classList.add('fa-check');
            } else {
                lowUpperCase.classList.add('fa-circle');
                lowUpperCase.classList.remove('fa-check');
            }
            //If it has numbers and characters
            if (password.match(/([0-9])/)) {
                strength += 1;
                number.classList.remove('fa-circle');
                number.classList.add('fa-check');
            } else {
                number.classList.add('fa-circle');
                number.classList.remove('fa-check');
            }
            //If it has one special character
            if (password.match(/([!,%,&,@,$,^,*,?,_,~])/)) {
                strength += 1;
                specialChar.classList.remove('fa-circle');
                specialChar.classList.add('fa-check');
            } else {
                specialChar.classList.add('fa-circle');
                specialChar.classList.remove('fa-check');
            }
            //If password is greater than 7
            if (password.length > 7) {
                strength += 1;
                eightChar.classList.remove('fa-circle');
                eightChar.classList.add('fa-check');
            } else {
                eightChar.classList.add('fa-circle');
                eightChar.classList.remove('fa-check');
            }

            // If value is less than 2
            if ((password || '').length == 0) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.style = 'width: 0%';

            } else if (strength < 2) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.add('progress-bar-danger');
                passwordStrength.style = 'width: 10%';
            } else if (strength == 3) {
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.classList.add('progress-bar-warning');
                passwordStrength.style = 'width: 60%';
            } else if (strength == 4) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.classList.add('progress-bar-success');
                passwordStrength.style = 'width: 100%';
            }
        }
    }



    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                {/* <AppHeader/> */}
                <section className="mainContent full-width clearfix" style={{ padding: '0px' }}>
                    <div className='row' style={{ overflowY: 'scroll', overflowX: 'hidden', height: 'calc(100vh - 70px)' }}>
                        <div className='col-lg-7 col-md-6 col-sm-12 loginBackground'>
                        </div>
                        <div className='col-lg-5 col-md-6 col-sm-12'>
                            <div className='row'>
                                <div className='col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1'>
                                    <Logo />
                                    {
                                        this.state.validToken === false ?
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="password-form">
                                                        <div className="panel panel-default formPanel">
                                                            <div className="panel-heading bg-color-1 border-color-1">
                                                                <h3 className="panel-title" style={{ textTransform: 'none' }}>Reset Password</h3>
                                                            </div>
                                                            <div className="panel-body" style={{ textAlign: 'center' }}>
                                                                <label className="color-3"><i className="fa fa-exclamation-circle" aria-hidden="true"></i>{" Your registration link has expired please contact your system administrator."}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> : null
                                    }
                                    {
                                        this.state.validToken === true ?
                                            <div className="row">
                                                <form className="password-form" onSubmit={this.handleSubmit.bind(this)}>
                                                    <div className="col-md-12">
                                                        <div className="panel panel-default formPanel">
                                                            <div className="panel-heading bg-color-1 border-color-1">
                                                                <h3 className="panel-title" style={{ textTransform: 'none' }}>Enter New Password </h3>
                                                            </div>
                                                            <div className="panel-body">
                                                                <div className="form-group formField">
                                                                    <input type="password" className="form-control"
                                                                        name="pwd" id="password" placeholder="New Password"
                                                                        onKeyUp={this.checkPass} onChange={(e) => this.onChange(e)}
                                                                        required />
                                                                </div>
                                                                <div className="form-group formField">
                                                                    <input type="password" className="form-control"
                                                                        name="cpwd" id="cpwd" placeholder="Confirm Password"
                                                                        onKeyUp={this.checkPass} required />
                                                                    <span id='message'></span>
                                                                </div>
                                                                <div className='form-group formField'>
                                                                    <div id="popover-password">
                                                                        <p><span id="result"></span></p>
                                                                        <div className="progress">
                                                                            <div id="password-strength"
                                                                                className="progress-bar"
                                                                                role="progressbar"
                                                                                aria-valuenow="40"
                                                                                aria-valuemin="0"
                                                                                aria-valuemax="100"
                                                                                style={{ width: "0%" }}>
                                                                            </div>
                                                                        </div>
                                                                        <ul className="list-unstyled">
                                                                            <li className="">
                                                                                <span className="low-upper-case">
                                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                                    &nbsp;Lowercase &amp; Uppercase
                                                                                </span>
                                                                            </li>
                                                                            <li className="">
                                                                                <span className="one-number">
                                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                                    &nbsp;Number (0-9)
                                                                                </span>
                                                                            </li>
                                                                            <li className="">
                                                                                <span className="one-special-char">
                                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                                    &nbsp;Special Character (!@$%^&*)
                                                                                </span>
                                                                            </li>
                                                                            <li className="">
                                                                                <span className="eight-character">
                                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                                    &nbsp;Atleast 8 Character
                                                                                </span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group formField">
                                                                    <button type="submit" id="submit"
                                                                        className="btn btn-primary  bg-color-3 btn-block border-color-3"
                                                                        style={{ marginLeft: '0px' }}>Submit
                                                                    </button>
                                                                </div>
                                                                <span id='message2'></span>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

}

reset.contextTypes = {
    router: PropTypes.object.isRequired
}

export default reset;


// WEBPACK FOOTER //
// ./src/components/Auth/resetPassword.jsx